import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular/lazy';
import { RegisterService } from 'src/app/services/register.service';
import { PricingTierService } from 'src/app/services/pricing-tier.service';
import { SupportedCurrencyService } from 'src/app/services/supported-currency.service';
import moment from 'moment';
import { StorageService } from 'src/app/services/storage.service';
import { ConnectedAccountService } from 'src/app/services/connected-account.service';
import { DateTimePickerPage } from 'src/app/modals/date-time-picker/date-time-picker.page';
import { APIService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { ObserverService } from 'src/app/services/observer.service';
import { OrganisationService } from 'src/app/services/organisation.service';
import { OrganisationPickerPage } from 'src/app/modals/organisation-picker/organisation-picker.page';
import { AffiliatePickerPage } from 'src/app/modals/affiliate-picker/affiliate-picker.page';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-order-filter',
    templateUrl: './order-filter.page.html',
    styleUrls: ['./order-filter.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrderFilterPage implements OnInit {
    @Input() affiliate_id;
    @Input() archived;
    @Input() awaiting_payment_method;
    @Input() channel;
    @Input() currency_id;
    @Input() date_from;
    @Input() date_to;
    @Input() fulfillment_status;
    @Input() is_awaiting_fulfillment;
    @Input() is_awaiting_payment;
    @Input() location_id;
    @Input() organisation_id;
    @Input() payment_status;
    @Input() pricing_tier_id;
    @Input() refund_status;
    @Input() register_id;
    @Input() return_status;
    @Input() status;
    @Input() timeframe;

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    filter_params = {};
    pricing_tiers = [];
    supported_currencies = null;
    registers = [];
    current_register_id = null;
    register = null;
    locations = [];
    organisation = null;
    organisation_title = null;
    @Input() hide_organisation_selector = false
    affiliate = null;
    affiliate_name = null;
    moment = moment;
    formatted_date_from = null;
    formatted_date_to = null;
    modal_css_class = '';
    date_modal_css_class = '';

    timeframe_options: any = { header: 'Timeframe' };
    is_awaiting_fulfillment_options: any = { header: 'Awaiting fulfillment' };
    is_awaiting_payment_options: any = { header: 'Awaiting payment' };
    status_options: any = { header: 'Status' };
    payment_status_options: any = { header: 'Payment status' };
    fulfillment_status_options: any = { header: 'Fulfillment status' };
    return_status_options: any = { header: 'Return status' };
    refund_status_options: any = { header: 'Refund status' };
    awaiting_payment_method_options: any = { header: 'Awaiting payment method' };
    channel_options: any = { header: 'Channel' };
    register_options: any = { header: 'Register' };
    pricing_tier_options: any = { header: 'Pricing tier' };
    currency_options: any = { header: 'Currency' };
    location_options: any = { header: 'Location' };
    archived_options: any = { header: 'Archived' };

    // modal flags
    date_picker_modal_open = false;
    organisation_picker_modal_open = false;
    affiliate_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private registerService: RegisterService,
        private pricingTierService: PricingTierService,
        private supportedCurrencyService: SupportedCurrencyService,
        private storageService: StorageService,
        private connectedAccountService: ConnectedAccountService,
        private router: Router,
        private apiService: APIService,
        private authService: AuthService,
        private observerService: ObserverService,
        private organisationService: OrganisationService,
        private userService: UserService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
            this.date_modal_css_class = 'backdrop';
        }

        this.loadData().then(async () => {

            if(this.timeframe) {

                this.filter_params['timeframe'] = this.timeframe;

                if(this.filter_params['timeframe'] == 'custom') {

                    if(this.date_from || this.date_to) {
                        this.storageService.get("connected_account_id").then((connected_account_id) => {
                            if(connected_account_id) {
                                this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account: any) => {
                                    if(connected_account['user_id']) {
                                        this.userService.getUser(connected_account['user_id']).then((user: any) => {
                                            if(this.date_from) {
                                                this.filter_params['date_from'] = this.moment.utc(this.date_from).tz(user.timezone.code).toISOString(true);
                                                this.formatted_date_from = this.moment(this.filter_params['date_from']).format("D MMM YYYY, HH:mm");
                                            }
                                            if(this.date_to) {
                                                this.filter_params['date_to'] = this.moment.utc(this.date_to).tz(user.timezone.code).toISOString(true);
                                                this.formatted_date_to = this.moment(this.filter_params['date_to']).format("D MMM YYYY, HH:mm");
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }

                }
            }

            if(this.is_awaiting_fulfillment != undefined) {
                this.filter_params['is_awaiting_fulfillment'] = this.is_awaiting_fulfillment;
            }

            if(this.is_awaiting_payment != undefined) {
                this.filter_params['is_awaiting_payment'] = this.is_awaiting_payment;
            }

            if(this.status) {
                this.filter_params['status'] = this.status;
            }

            if(this.payment_status) {
                this.filter_params['payment_status'] = this.payment_status;
            }

            if(this.fulfillment_status) {
                this.filter_params['fulfillment_status'] = this.fulfillment_status;
            }

            if(this.return_status) {
                this.filter_params['return_status'] = this.return_status;
            }

            if(this.refund_status) {
                this.filter_params['refund_status'] = this.refund_status;
            }

            if(this.awaiting_payment_method) {
                this.filter_params['awaiting_payment_method'] = this.awaiting_payment_method;
            }

            if(this.channel) {
                this.filter_params['channel'] = this.channel;
            }

            if(this.register_id) {
                this.filter_params['register_id'] = this.register_id;
            }

            if(this.pricing_tier_id) {
                this.filter_params['pricing_tier_id'] = this.pricing_tier_id;
            }

            if(this.currency_id) {
                this.filter_params['currency_id'] = this.currency_id;
            }

            if(this.location_id) {
                this.filter_params['location_id'] = this.location_id;
            }

            if(this.archived != undefined) {
                this.filter_params['archived'] = this.archived;
            }

            if(this.organisation_id) {
                this.filter_params['organisation_id'] = this.organisation_id;
                this.organisationService.getOrganisation(this.filter_params['organisation_id'],{}).then((organisation) => {
                    if(organisation) {
                        this.organisation_title = organisation["title"];
                    }
                })
                .catch(() => { });
            }

            if(this.affiliate_id) {
                this.filter_params['affiliate_id'] = this.affiliate_id;
                this.loadAffiliate().then(() => {
                    this.affiliate_name = this.affiliate.name;
                })
                .catch(() => { });
            }

        })
        .catch(() => { });

        this.observerService.subscribe('network_status_changed|order_filter_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to filter orders, please check your network connection and try again.");
                }
            }
        });

    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading registers").then(() => {
                this.loadRegisters().then(() => {
                    this.loading_spinner.message = "Loading pricing tiers";
                    this.loadPricingTiers().then(() => {
                        this.loading_spinner.message = "Loading currencies";
                        this.loadSupportedCurrencies().then(() => {
                            this.storageService.get("register_id").then((register_id) => {
                                if(register_id) {
                                    this.current_register_id = register_id;
                                    this.registerService.getRegister(this.current_register_id).then((register) => {
                                        if(register) {
                                            this.register = register;
                                            for(let i = 0; i < this.supported_currencies.length; i++) {
                                                // NOTE: default currency
                                                if(this.supported_currencies[i].id == this.register['location'].default_currency.id) {
                                                    let register_location_default_currency = this.supported_currencies.splice(i, 1)[0];
                                                    this.supported_currencies.unshift(register_location_default_currency);
                                                    break;
                                                }
                                            }
                                        }
                                    })
                                    .catch(() => { });
                                }
                            })
                            .catch(() => { });
                            this.loading_spinner.message = "Loading locations";
                            this.loadLocations().then(() => {
                                this.loading_spinner.dismiss();
                                resolve();
                            })
                            .catch(() => {
                                this.loading_spinner.dismiss();
                                reject();
                            });
                        })
                        .catch(() => {
                            this.loading_spinner.dismiss();
                            reject();
                        });
                    })
                    .catch(() => {
                        this.loading_spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    loadRegisters() {
        return new Promise<void>((resolve, reject) => {
            this.registers = [];
            this.registerService.getRegisters().then((registers:[]) => {
                if(registers) {
                    this.registers = registers;
                    let register_found = false
                    for(let i = 0; i < this.registers.length; i++) {
                        if(this.registers[i].id == this.filter_params['register_id']) {
                            register_found = true;
                            break
                        }
                    }
                    if(!register_found) {
                        delete this.filter_params['register_id'];
                    }
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    loadPricingTiers() {
        return new Promise<void>((resolve, reject) => {
            this.pricing_tiers = [];
            this.pricingTierService.getPricingTiers().then((pricing_tiers: any) => {
                if(pricing_tiers) {
                    pricing_tiers.sort((a, b) => {
                        if(a['order'] < b['order']) { return -1; }
                        if(a['order'] > b['order']) { return 1; }
                        return 0;
                    });
                    this.pricing_tiers = pricing_tiers;
                    let pricing_tier_found = false
                    for(let i = 0; i < this.pricing_tiers.length; i++) {
                        if(this.pricing_tiers[i].id == this.filter_params['pricing_tier_id']) {
                            pricing_tier_found = true;
                            break
                        }
                    }
                    if(!pricing_tier_found) {
                        delete this.filter_params['pricing_tier_id'];
                    }
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    loadSupportedCurrencies() {
        return new Promise<void>((resolve, reject) => {
            this.supportedCurrencyService.getSupportedCurrencies().then((supported_currencies: any) => {
                if(supported_currencies) {
                    supported_currencies.sort((a, b) => {
                        if (a['title'].toLowerCase() < b['title'].toLowerCase()) { return -1; }
                        if (a['title'].toLowerCase() > b['title'].toLowerCase()) { return 1; }
                        return 0;
                    });
                    this.supported_currencies = supported_currencies;
                    let currency_found = false
                    for(let i = 0; i < this.supported_currencies.length; i++) {
                        if(this.supported_currencies[i].id == this.filter_params['currency_id']) {
                            currency_found = true;
                            break
                        }
                    }
                    if(!currency_found) {
                        delete this.filter_params['currency_id'];
                    }
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        })
    }

    loadLocations() {
        return new Promise<void>((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.getLocations().then((locations: []) => {
                    if(locations) {
                        this.locations = locations;
                        let location_found = false
                        for(let i = 0; i < this.locations.length; i++) {
                            if(this.locations[i].id == this.filter_params['location_id']) {
                                location_found = true;
                                break
                            }
                        }
                        if(!location_found) {
                            delete this.filter_params['location_id'];
                        }
                    }
                    resolve();
                })
                .catch((error) => {
                    if(error) {
                        if(error.status) {
                            if(error.status == 400) {
                                this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to retrieve a list of locations.");
                            }
                            else if(error.status == 403) {
                                this.presentAlert("Insufficient permissions", "You don't have permission to view location.");
                            }
                            else if(error.status == 404) {
                                this.presentAlert("Unavailable", "Unfortunately we're unable to retrieve a list of locations at this time.");
                            }
                            else if(error.status == 0) {
                                this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                            }
                        }
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    loadAffiliate() {
        return new Promise<void>((resolve, reject) => {
            this.affiliate = null;
            this.authService.isLoggedIn().then(() => {
                this.apiService.getAffiliate(this.filter_params['affiliate_id']).then((affiliate) => {
                    if(affiliate) {
                        this.affiliate = affiliate;
                    }
                    resolve();
                })
                .catch((error) => {
                    if(error.status == 400) {
                        this.presentAlert('Unknown error', 'Unfortunately something went wrong when trying to retrieve an affiliate.');
                    } 
                    else if(error.status == 403) {
                        this.presentAlert('Insufficient permissions', "You don't have permission to view an affiliate.");
                    } 
                    else if(error.status == 404) {
                        this.presentAlert('Unavailable', "Unfortunately we're unable to retrieve an affiliate at this time.");
                    }
                    else if(error.status == 0) {
                        this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    filter() {

        let validated = true;

        if(this.filter_params["timeframe"]) {

            if(this.filter_params['timeframe'] == "today") {
                this.filter_params['date_from'] = this.moment().startOf("day").utc().format();
                this.filter_params['date_to'] = this.moment().endOf("day").utc().format();
            }
            else if(this.filter_params['timeframe'] == "yesterday") {
                this.filter_params['date_from'] = this.moment().startOf("day").subtract(1, 'days').utc().format();
                this.filter_params['date_to'] = this.moment().endOf("day").subtract(1, 'days').utc().format();
            }
            else if(this.filter_params['timeframe'] == "this_week") {
                this.filter_params['date_from'] = this.moment().startOf("isoWeek").utc().format();
                this.filter_params['date_to'] = this.moment().endOf("isoWeek").utc().format();
            }
            else if(this.filter_params['timeframe'] == "last_week") {
                this.filter_params['date_from'] = this.moment().startOf("isoWeek").subtract(1, 'weeks').utc().format();
                this.filter_params['date_to'] = this.moment().endOf("isoWeek").subtract(1, 'weeks').utc().format();
            }
            else if(this.filter_params['timeframe'] == "this_month") {
                this.filter_params['date_from'] = this.moment().startOf("month").utc().format();
                this.filter_params['date_to'] = this.moment().endOf("month").utc().format();
            }
            else if(this.filter_params['timeframe'] == "last_month") {
                this.filter_params['date_from'] = this.moment().startOf("month").subtract(1, 'months').utc().format();
                this.filter_params['date_to'] = this.moment().endOf("month").subtract(1, 'months').utc().format();
            }
            else if(this.filter_params['timeframe'] == "custom") {

                if( (this.filter_params['date_from'] == null || this.filter_params['date_from'].trim() === "") && (this.filter_params['date_to'] == null || this.filter_params['date_to'].trim() === "") ) {
                    validated = false;
                    this.presentAlert("Missing dates", "Please select a From date and/or a To date when using a Custom timeframe.");
                }
                else {
                    if(this.filter_params['date_from']) {
                        this.filter_params['date_from'] = this.moment(this.filter_params['date_from']).utc().format();
                    }
                    if(this.filter_params['date_to']) {
                        this.filter_params['date_to'] = this.moment(this.filter_params['date_to']).utc().format();
                    }
                }

            }

        }

        if(validated) {
            this.modalController.dismiss(this.filter_params);
        }

    }

    clearTimeframe() {

        if(this.filter_params['timeframe'] == "custom") {

            if(this.filter_params['date_from']) {
                delete this.filter_params["date_from"];
                this.formatted_date_from = null;
            }
            if(this.filter_params['date_to']) {
                delete this.filter_params["date_to"];
                this.formatted_date_to = null;
            }

        }

        delete this.filter_params['timeframe'];

    }

    clearIsAwaitingFulfillment() {
        delete this.filter_params['is_awaiting_fulfillment'];
    }

    clearIsAwaitingPayment() {
        delete this.filter_params['is_awaiting_payment'];
    }

    clearStatus() {
        delete this.filter_params['status'];
    }

    clearPaymentStatus() {
        delete this.filter_params['payment_status'];
    }

    clearFulfillmentStatus() {
        delete this.filter_params['fulfillment_status'];
    }

    clearReturnStatus() {
        delete this.filter_params['return_status'];
    }

    clearRefundStatus() {
        delete this.filter_params['refund_status'];
    }

    clearAwaitingPaymentMethod() {
        delete this.filter_params['awaiting_payment_method'];
    }

    clearChannel() {
        delete this.filter_params['channel'];
    }

    clearRegister() {
        delete this.filter_params['register_id'];
    }

    clearPricingTier() {
        delete this.filter_params['pricing_tier_id'];
    }

    clearCurrency() {
        delete this.filter_params['currency_id'];
    }

    clearLocation() {
        delete this.filter_params['location_id'];
    }

    clearArchived() {
        delete this.filter_params['archived'];
    }

    clearFilters() {
        this.presentSpinner("Clearing filters").then(() => {

            if(this.filter_params['timeframe']) {
                delete this.filter_params["timeframe"];
            }
            if(this.filter_params['date_from']) {
                delete this.filter_params["date_from"];
                this.formatted_date_from = null;
            }
            if(this.filter_params['date_to']) {
                delete this.filter_params["date_to"];
                this.formatted_date_to = null;
            }
            if('is_awaiting_fulfillment' in this.filter_params) {
                delete this.filter_params["is_awaiting_fulfillment"];
            }
            if('is_awaiting_payment' in this.filter_params) {
                delete this.filter_params["is_awaiting_payment"];
            }
            if(this.filter_params['status']) {
                delete this.filter_params["status"];
            }
            if(this.filter_params['payment_status']) {
                delete this.filter_params["payment_status"];
            }
            if(this.filter_params['fulfillment_status']) {
                delete this.filter_params["fulfillment_status"];
            }
            if(this.filter_params['refund_status']) {
                delete this.filter_params["refund_status"];
            }
            if(this.filter_params['return_status']) {
                delete this.filter_params["return_status"];
            }
            if(this.filter_params['awaiting_payment_method']) {
                delete this.filter_params["awaiting_payment_method"];
            }
            if(this.filter_params['channel']) {
                delete this.filter_params["channel"];
            }
            if(this.filter_params['register_id']) {
                delete this.filter_params["register_id"];
            }
            if(this.filter_params['pricing_tier_id']) {
                delete this.filter_params["pricing_tier_id"];
            }
            if(this.filter_params['currency_id']) {
                delete this.filter_params["currency_id"];
            }
            if(this.filter_params['location_id']) {
                delete this.filter_params["location_id"];
            }

            // NOTE: order list has been called from organisation view, need to prevent organisation_id being cleared
            if(!this.hide_organisation_selector && this.filter_params['organisation_id']) {
                delete this.filter_params["organisation_id"];
                this.organisation_title = null;
            }

            if(this.filter_params['affiliate_id']) {
                delete this.filter_params["affiliate_id"];
                this.affiliate_name = null;
            }
            if('archived' in this.filter_params) {
                delete this.filter_params["archived"];
            }

            this.spinner.dismiss();

        });
    }

    async presentFromDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.filter_params['date_from'] ? this.filter_params['date_from'] : ""),
                    format: "date-time",
                    clear_date: true
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "date_deleted") {
                        delete this.filter_params["date_from"];
                        this.formatted_date_from = null;
                    }
                    else {
                        this.filter_params['date_from'] = data.data['date'];
                        this.formatted_date_from = this.moment(this.filter_params['date_from']).format("D MMM YYYY, HH:mm");
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentToDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.filter_params['date_to'] ? this.filter_params['date_to'] : ""),
                    format: "date-time",
                    clear_date: true
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "date_deleted") {
                        delete this.filter_params["date_to"];
                        this.formatted_date_to = null;
                    }
                    else {
                        this.filter_params['date_to'] = data.data['date'];
                        this.formatted_date_to = this.moment(this.filter_params['date_to']).format("D MMM YYYY, HH:mm");
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentOrganisationPickerModal() {
        if(!this.organisation_picker_modal_open) {
            this.organisation_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: OrganisationPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    organisation_id: (this.filter_params['organisation_id'] ? this.filter_params['organisation_id'] : null),
                    hide_add_organisation_button: true
                }
            });
            modal.onDidDismiss().then((data) => {
                this.organisation_picker_modal_open = false;
                if(data.data) {
                    if(data.data['picker_action'] == "organisation_deleted") {
                        delete this.filter_params["organisation_id"];
                        this.organisation_title = null;
                    }
                    else {
                        this.filter_params['organisation_id'] = data.data['organisation_id'];
                        this.organisation_title = data.data['organisation_title'];
                    }

                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAffiliatePickerModal() {
        if(!this.affiliate_picker_modal_open) {
            this.affiliate_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: AffiliatePickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    affiliate_id: (this.filter_params['affiliate_id'] ? this.filter_params['affiliate_id'] : null)
                }
            });
            modal.onDidDismiss().then((data) => {
                this.affiliate_picker_modal_open = false;
                if(data.data) {
                    if(data.data['picker_action'] == "affiliate_deleted") {
                        delete this.filter_params["affiliate_id"];
                        this.affiliate_name = null;
                    }
                    else {
                        this.filter_params['affiliate_id'] = data.data['affiliate_id'];
                        this.affiliate_name = data.data['affiliate_name'];
                    }

                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
